import React from 'react';

import ReviewList from '~/components-ds/ReviewList';
import { COVER_DETAILS_BREAKDOWN_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { Cover } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

const ReviewBreakdown: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.breakdown' });

  const { breakdown } = useCoverDetails();

  const reviewList = [
    {
      label: getTextContent('sumInsured'),
      data: currencyFormatter(breakdown?.sumInsured, CurrencyFormat.Comma),
    },
    {
      label: getTextContent('numberOfItems'),
      data: breakdown?.numberOfItems?.toString() ?? '0',
    },
    {
      label: getTextContent('deteriorationOfStocks'),
      data: currencyFormatter(breakdown?.deteriorationOfStock, CurrencyFormat.Comma),
    },
  ];

  return (
    <ReviewList
      list={reviewList.reduce(
        (prev, curr, idx) => ({
          ...prev,
          [String(idx)]: {
            id: idx,
            name: curr.label,
            label: curr.label,
            value: curr.data,
          },
        }),
        {}
      )}
      title={Cover.Breakdown}
      editRoute={COVER_DETAILS_BREAKDOWN_ROUTE}
    />
  );
};

export default ReviewBreakdown;
